import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Col, Row, Card, Badge } from "react-bootstrap";
import { ClipLoader } from "react-spinners";
import { MapPin, Phone, Globe, Mail, MailCheck } from "lucide-react";
import localization from "services/localization";
import CustomSelect from "views/Components/CustomSelect";
import { ORGANIZATION_TYPES, ORGANIZATION_SUB_TYPES } from "services/constants";
import ArrayInput from "views/Components/ArrayInput";
import ImageLibrary from "views/Components/ResourceLibrary/ImageLibrary";

const AddEditOrganizationModal = ({
  show,
  title,
  formData,
  onChange,
  onSubmit,
  onClose,
  loading,
  errors,
}) => {
  const [schoolLogo, setSchoolLogo] = useState(null);

  useEffect(() => {
    if (show) {
      console.log("formData:", formData);
    }
  }, [show]);
  const handleUpperCaseChange = (e) => {
    const { name, value } = e.target;
    const upper = [
      "code",
      "codice_meccanografico",
      "piva",
      "codice_fiscale",
    ].includes(name)
      ? value.toUpperCase()
      : value;
    onChange(name, upper);
  };

  const addArrayValue = (field, value) => {
    const current = formData[field] || [];
    onChange(field, [...current, value]);
  };

  const removeArrayValue = (field, value) => {
    const current = formData[field] || [];
    onChange(
      field,
      current.filter((v) => v !== value),
    );
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="xl"
      className="themed-modal addEditModal"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Form onSubmit={onSubmit}>
        <Modal.Body className="organization-modal">
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group className="required">
                <Form.Label className="bootstrap-label">
                  {localization.organization_name || "Organization Name"}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name || ""}
                  onChange={(e) => onChange("name", e.target.value)}
                  placeholder={
                    localization.enter_organization_name ||
                    "Enter organization name"
                  }
                  isInvalid={!!errors.name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group className="required">
                <Form.Label className="bootstrap-label">
                  {localization.type || "Type"}
                </Form.Label>
                <CustomSelect
                  options={ORGANIZATION_TYPES}
                  value={ORGANIZATION_TYPES.find(
                    (opt) =>
                      opt.value.trim().toLowerCase() ===
                      formData.type?.trim().toLowerCase(),
                  )}
                  onChange={(opt) => onChange("type", opt?.value || "")}
                  placeholder={localization.select_a_type || "Select a type"}
                />
                {errors.type && (
                  <div className="text-danger small mt-1">{errors.type}</div>
                )}
              </Form.Group>
            </Col>
            {ORGANIZATION_TYPES.find((opt) => opt.value === formData.type)
              ?.value === "Scuola secondaria di secondo grado" && (
              <Col md={6} className="mb-3">
                <Form.Group className="required">
                  <Form.Label className="bootstrap-label">
                    {localization.sub_type || "Sub Type"}
                  </Form.Label>
                  <CustomSelect
                    options={ORGANIZATION_SUB_TYPES}
                    value={ORGANIZATION_SUB_TYPES.find(
                      (opt) => opt.value === formData.sub_type,
                    )}
                    onChange={(opt) => onChange("sub_type", opt?.value || "")}
                    placeholder={
                      localization.select_a_sub_type || "Select a sub type"
                    }
                  />
                </Form.Group>
              </Col>
            )}

            <Col md={6} className="mb-3">
              <Form.Group className="required">
                <Form.Label className="bootstrap-label">
                  {localization.school_code || "Code"}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="code"
                  value={formData.code || ""}
                  onChange={handleUpperCaseChange}
                  placeholder={
                    localization.enter_school_code || "Enter school code"
                  }
                  isInvalid={!!errors.code}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.code}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group className="required">
                <Form.Label className="bootstrap-label">
                  {localization.codice_meccanografico ||
                    "Codice Meccanografico"}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="codice_meccanografico"
                  value={formData.codice_meccanografico || ""}
                  onChange={handleUpperCaseChange}
                  placeholder={
                    localization.enter_codice_meccanografico ||
                    "Enter codice meccanografico"
                  }
                  isInvalid={!!errors.codice_meccanografico}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.codice_meccanografico}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group className="required">
                <Form.Label className="bootstrap-label">
                  {localization.piva || "P.IVA"}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="piva"
                  value={formData.piva || ""}
                  onChange={handleUpperCaseChange}
                  placeholder={localization.enter_piva || "Enter P.IVA"}
                  isInvalid={!!errors.piva}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.piva}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={6} className="mb-3">
              <Form.Group className="required">
                <Form.Label className="bootstrap-label">
                  {localization.codice_fiscale || "Codice Fiscale"}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="codice_fiscale"
                  value={formData.codice_fiscale || ""}
                  onChange={handleUpperCaseChange}
                  placeholder={
                    localization.enter_codice_fiscale || "Enter Codice Fiscale"
                  }
                  isInvalid={!!errors.codice_fiscale}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.codice_fiscale}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group className="required">
                <Form.Label className="bootstrap-label">
                  {localization.dirigente_scolastico || "School Principal"}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="dirigente_scolastico"
                  value={formData.dirigente_scolastico || ""}
                  onChange={(e) =>
                    onChange("dirigente_scolastico", e.target.value)
                  }
                  placeholder={
                    localization.enter_principal || "Enter principal"
                  }
                  isInvalid={!!errors.dirigente_scolastico}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.dirigente_scolastico}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label className="bootstrap-label">
                  {localization.institution_logo_url || "Institution Logo URL"}
                </Form.Label>
                <Form.Control
                  type="url"
                  name="institution_logo"
                  value={formData.institution_logo || ""}
                  onChange={(e) => onChange("institution_logo", e.target.value)}
                  placeholder={
                    localization.enter_institution_logo ||
                    "Enter institution logo"
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group className="required">
                <Form.Label className="bootstrap-label">
                  {localization.description || "Description"}
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  name="description"
                  value={formData.description || ""}
                  onChange={(e) => onChange("description", e.target.value)}
                  placeholder={
                    localization.enter_description || "Enter description"
                  }
                  isInvalid={!!errors.description}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.description}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Card className="mb-4 shadow-sm instruction-card">
                <div className="instruction-card-header">
                  <MapPin size={20} className="text-primary" />
                  <h5 className="mb-0 font-semibold">
                    {localization.organization_address ||
                      "Organization Address"}
                  </h5>
                </div>
                <Card.Body>
                  <Row>
                    <Col md={6} className="mb-3">
                      <Form.Group className="required">
                        <Form.Label className="bootstrap-label">
                          {localization.address || "Address"}
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="address"
                          value={formData.address || ""}
                          onChange={(e) => onChange("address", e.target.value)}
                          placeholder={
                            localization.enter_address || "Enter address"
                          }
                          isInvalid={!!errors.address}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.address}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group className="required">
                        <Form.Label className="bootstrap-label">
                          {localization.city || "City"}
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="city"
                          value={formData.city || ""}
                          onChange={(e) => onChange("city", e.target.value)}
                          placeholder={localization.enter_city || "Enter city"}
                          isInvalid={!!errors.city}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.city}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group className="required">
                        <Form.Label className="bootstrap-label">
                          {localization.province || "Province"}
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="province"
                          value={formData.province || ""}
                          onChange={(e) => onChange("province", e.target.value)}
                          placeholder={
                            localization.enter_province || "Enter province"
                          }
                          isInvalid={!!errors.province}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.province}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group className="required">
                        <Form.Label className="bootstrap-label">
                          {localization.postal_code || "Postal Code"}
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="postal_code"
                          value={formData.postal_code || ""}
                          onChange={(e) =>
                            onChange("postal_code", e.target.value)
                          }
                          placeholder={
                            localization.enter_postal_code ||
                            "Enter postal code"
                          }
                          isInvalid={!!errors.postal_code}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.postal_code}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group className="required">
                        <Form.Label className="bootstrap-label">
                          {localization.region || "Region"}
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="region"
                          value={formData.region || ""}
                          onChange={(e) => onChange("region", e.target.value)}
                          placeholder={
                            localization.enter_region || "Enter region"
                          }
                          isInvalid={!!errors.region}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.region}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group className="required">
                        <Form.Label className="bootstrap-label">
                          {localization.country || "Country"}
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="country"
                          value={formData.country || ""}
                          onChange={(e) => onChange("country", e.target.value)}
                          placeholder={
                            localization.enter_country || "Enter country"
                          }
                          isInvalid={!!errors.country}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.country}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            {/* Organization Contact */}
            <Col md={12} className="mb-3">
              <ArrayInput
                label="Phone Numbers"
                placeholder="+39 123 456 789"
                values={formData.contact_phone}
                onChange={(v) => onChange("contact_phone", v)}
                Icon={Phone}
                addButtonText={localization.add_phone || "Add Phone"}
              />
              <ArrayInput
                label="Websites"
                placeholder="https://example.com"
                values={formData.website}
                onChange={(v) => onChange("website", v)}
                Icon={Globe}
                addButtonText={localization.add_website || "Add Website"}
              />
              <ArrayInput
                label="Emails"
                placeholder="info@example.com"
                values={formData.contact_email}
                onChange={(v) => onChange("contact_email", v)}
                Icon={Mail}
                addButtonText={localization.add_email || "Add Email"}
              />

              <ArrayInput
                label="PEC Emails"
                placeholder="school@pec.it"
                values={formData.pec}
                onChange={(v) => onChange("pec", v)}
                Icon={MailCheck}
                addButtonText={localization.add_pec_email || "Add PEC Email"}
                isRequired
                errors={errors}
              />
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group className="required">
                <Form.Label className="bootstrap-label">
                  {localization.extra_info || "Extra Info"}
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  name="extra_info"
                  value={formData.extra_info || ""}
                  onChange={(e) => onChange("extra_info", e.target.value)}
                  placeholder={
                    localization.enter_extra_info || "Enter extra info"
                  }
                  isInvalid={!!errors.extra_info}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.extra_info}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            {formData.id && (
              <Col md={12} className="mb-3">
                <ImageLibrary
                  value={formData.organization_logo || ""}
                  onChange={(imageUrl) => {
                    onChange("organization_logo", imageUrl);
                  }}
                  label="Upload Logo"
                  aspectRatio={1}
                  schoolId={formData.id}
                />
              </Col>
            )}
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button className="action-btn secondary" onClick={onClose}>
            {localization.cancel || "Cancel"}
          </Button>
          <Button
            className="action-btn primary"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <ClipLoader size={20} color="var(--primary-icon)" />
            ) : (
              localization.save || "Save"
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddEditOrganizationModal;
